<template>
    <p v-if="label" class="menu-label tw:uppercase tw:text-xs tw:tracking-widest tw:text-gray-600 tw:font-semibold tw:mt-4 tw:mb-2 first:tw:mt-0">
        {{ label }}
    </p>
    <ul class="menu-list tw:leading-tight">
        <slot />
    </ul>
</template>

<script>
/**
 * EMenuItem - Abstraction wrapper to replicate Buefy b-menu-listt functionality
 *
 * Usage:
 *   <e-menu>
 *     <e-menu-list label="General">
 *       <e-menu-item label="Dashboard"></e-menu-item>
 *       <e-menu-item label="Profile"></e-menu-item>
 *     </e-menu-list>
 *     <e-menu-list label="Administration">
 *       <e-menu-item label="Users"></e-menu-item>
 *       <e-menu-item label="Settings"></e-menu-item>
 *     </e-menu-list>
 *   </e-menu>
 *
 * Props:
 *   - label: String - Group/section label
 *
 * All Buefy b-menu-list props, events, and slots are supported in Buefy mode.
 */
export default {
    name: 'EMenuList',
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            default: undefined,
        },
    },
};
</script>
